import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DateService } from "@services/date.service";
import { ITemperatureAlarmRecord } from "@temperature/_models/temperature/ITemperatureAlarmRecord";
import { ITemperatureRecord } from "@temperature/_models/temperature/ITemperatureRecord";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class TemperatureRecordService {
    constructor(private readonly http: HttpClient,
        private readonly dateService: DateService) { }

    getTemperatureRecord(id: number): Observable<ITemperatureRecord> {
        return this.http.get<ITemperatureRecord>(`/api/temperature/records/${id}`);
    }

    getTemperatureAlarmRecord(id: number): Observable<ITemperatureAlarmRecord> {
        return this.http.get<ITemperatureAlarmRecord>(`/api/temperaturealarm/${id}`);
    }

    getLatestTemperatureRecords(ignoreOldData = true): Observable<ITemperatureRecord[]> {
        return this.http.get<ITemperatureRecord[]>(`/api/temperature/latest`).pipe(tap(records => {
            if (!ignoreOldData) {
                return records;
            }
            return records.filter(record => this.recordIsToday(record))
        }))
    }

    getLatestTemperatureRecordsForVehicle(vehicleId: number): Observable<ITemperatureRecord[]> {
        return this.http.get<ITemperatureRecord[]>(`/api/temperature/${vehicleId}/latest`);
    }

    getTemperatureRecordsForVehicle(vehicleId: number, startDate: Date, endDate: Date): Observable<ITemperatureRecord[]> {
        const options = { params: new HttpParams().set("startDate", startDate.toISOString()).set("endDate", endDate.toISOString()) };

        return this.http.get<ITemperatureRecord[]>(`/api/temperature/${vehicleId}`, options).pipe(tap(records => {
            records.sort((a, b) => a.Id - b.Id);
            return records;
        }));
    }

    getTemperatureRecordsByParentTrackerImei(imei: string, startDate: Date, endDate: Date): Observable<ITemperatureRecord[]> {
        const options = { params: new HttpParams().set("startDate", startDate.toISOString()).set("endDate", endDate.toISOString()) };
                      
        return this.http.get<ITemperatureRecord[]>(`/api/temperature/records/trackingDevice/${imei}`, options);
    }

    private recordIsToday(record: ITemperatureRecord): boolean {
        const recordTime = new Date(record.Timestamp);
        const today = new Date();
        return this.dateService.isSameDate(recordTime, today);
    }
}
